import isGHMC, { formattedDate, formattedDateTypeTwo, getCurrentDate, getFirstDateOfMonth } from "../../../../Common/helper/helpar";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    TablePagination,
    Paper,
} from "@mui/material";

import { useEffect, useState } from "react";
import Loader from "../../../../Common/Loader/loader";
import { bouncy } from "ldrs";

import { TippingFeeCalculationFilters } from "./TippingFeeCalculationFilter";
import TippingFeeCalculationStore from "./store/TippingFeeCalculationStore";
import { useNavigate } from "react-router-dom";

const TippingFeeCalculationReport = () => {
    const { tippingFeeReportData, loading } = TippingFeeCalculationStore()

    const currentDate = getCurrentDate();
    const navigate = useNavigate()

    const totalHMSWTonnage = tippingFeeReportData.reduce((sum, item) => sum + (parseFloat(item.himsW_Tonnage) || 0), 0);
    const totalGHMCTonnage = tippingFeeReportData.reduce((sum, item) => sum + (parseFloat(item.ghmC_Tonnage) || 0), 0);
    const totalTonnage = tippingFeeReportData.reduce((sum, item) => sum + (parseFloat(item.total_Tonnage) || 0), 0);
    const totalHMSWTipping = tippingFeeReportData.reduce((sum, item) => sum + (parseFloat(item.himsW_Tipping) || 0), 0);
    const totalGHMCTipping = tippingFeeReportData.reduce((sum, item) => sum + (parseFloat(item.ghmC_Tipping) || 0), 0);
    const totalAmount = tippingFeeReportData.reduce((sum, item) => sum + (parseFloat(item.total_Amount) || 0), 0);


    const isProd = isGHMC();
    const headerStyles = {
        textAlign: "center",
        border: "1px solid #ddd",
        borderRight: "none",
        padding: "10px",
        color: "#fff",
        backgroundColor: isProd ? "#0d5da5" : "#EC1117",
    };
    const cellStyles = {
        textAlign: "center",
        border: "1px solid #ddd",
        borderRight: "none",
        padding: "10px",
        whiteSpace: "normal",
    };

    const innerTripReport = () => {
        navigate("/inner-tipping-fee-calculation-report")
    }

    return (
        <>
            {loading && <Loader />}
            <div style={{ width: "100%" }}>
                <div className="content">
                    <div className="page-content">
                        {/* <div className="d-flex p-2 mt-1 ml-2"> */}
                        <TippingFeeCalculationFilters />
                        {/* </div> */}
                        <div className="page-header text-start">
                            <div className="card">
                                <div className="card-body">
                                    {/* <MonthWiseAttendanceFilters /> */}
                                    {/* <TippingFeeCalculationFilters/> */}
                                    {/* <Paper> */}
                                    <div className="top-header d-flex justify-content-center align-items-center">
                                        <span>Tipping Fee Calcualtion Report</span>
                                    </div>
                                    <TableContainer
                                        component={Paper}
                                        sx={{
                                            width: "100%",
                                            border: "1px solid #ccc",
                                            maxHeight: 700,
                                        }}
                                    >
                                        <Table stickyHeader aria-label="sticky table">
                                            <TableHead
                                                className={`${isProd ? "bg-ghmc" : "bg-swm"}`}
                                                style={{ position: "sticky", top: 0 }}
                                            >
                                                <TableRow>
                                                    <TableCell rowSpan={2} sx={headerStyles}>S.No</TableCell>
                                                    <TableCell rowSpan={2} sx={headerStyles}>Date</TableCell>
                                                    <TableCell colSpan={3} sx={headerStyles} style={{ textAlign: "center" }}>
                                                        Tonnage
                                                    </TableCell>
                                                    <TableCell colSpan={2} sx={headerStyles} style={{ textAlign: "center" }}>
                                                        Tipping Fee
                                                    </TableCell>
                                                    <TableCell rowSpan={2} sx={headerStyles}>Total Amount</TableCell>
                                                </TableRow>
                                                <TableRow>
                                                    <TableCell sx={headerStyles}>HMSW</TableCell>
                                                    <TableCell sx={headerStyles}>GHMC</TableCell>
                                                    <TableCell sx={headerStyles}>Total</TableCell>
                                                    <TableCell sx={headerStyles}>HMSW</TableCell>
                                                    <TableCell sx={headerStyles}>GHMC</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {tippingFeeReportData?.length > 0 ? (
                                                    <>
                                                        {tippingFeeReportData.map((item, index) => (
                                                            <TableRow
                                                                key={index}
                                                                sx={{
                                                                    backgroundColor: isProd
                                                                        ? index % 2 === 0 ? "#8fc9ff" : "#aed8ff"
                                                                        : index % 2 === 0 ? "#F8CCCD" : "#ffeded",
                                                                }}
                                                            >
                                                                <TableCell sx={cellStyles}>{index + 1}</TableCell>
                                                                <TableCell sx={{ ...cellStyles, cursor: "pointer", color: 'blue' }} onClick={innerTripReport}>{formattedDate(item.transactionDate)}</TableCell>
                                                                <TableCell sx={cellStyles}>{item.himsW_Tonnage}</TableCell>
                                                                <TableCell sx={cellStyles}>{item.ghmC_Tonnage}</TableCell>
                                                                <TableCell sx={cellStyles}>{item.total_Tonnage}</TableCell>
                                                                <TableCell sx={cellStyles}>{item.himsW_Tipping}</TableCell>
                                                                <TableCell sx={cellStyles}>{item.ghmC_Tipping}</TableCell>
                                                                <TableCell sx={cellStyles}>{item.total_Amount}</TableCell>
                                                            </TableRow>
                                                        ))}
                                                        <TableRow>
                                                            <TableCell sx={cellStyles}><strong></strong></TableCell>
                                                            <TableCell sx={cellStyles}><strong>Total</strong></TableCell>
                                                            <TableCell sx={cellStyles}><strong>{totalHMSWTonnage}</strong></TableCell>
                                                            <TableCell sx={cellStyles}><strong>{totalGHMCTonnage}</strong></TableCell>
                                                            <TableCell sx={cellStyles}><strong>{totalTonnage}</strong></TableCell>
                                                            <TableCell sx={cellStyles}><strong>{totalHMSWTipping}</strong></TableCell>
                                                            <TableCell sx={cellStyles}><strong>{totalGHMCTipping}</strong></TableCell>
                                                            <TableCell sx={cellStyles}><strong>{totalAmount}</strong></TableCell>
                                                        </TableRow>
                                                    </>
                                                ) : (
                                                    <TableRow>
                                                        <TableCell sx={cellStyles} colSpan={8}>
                                                            <strong>No Data Available</strong>
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>

                                        </Table>
                                    </TableContainer>

                                    {/* </Paper> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
};

export default TippingFeeCalculationReport;
